<div class="modal-header">
    <div class="title">
        <h2 class="modal-title-prefix"><span translate="ACTION.ROLEACTION"></span></h2>
    </div>
    <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">
    <form [formGroup]="formGroup" class="">    
    <div class="row">
     <div class="col-12">
        <div class="form-group row">
          <div class="col-md-12">
            <yt-dropdown-picklist 
            [ModelName]="'userrole'" 
            [GetName]="'get'" 
            [ModelProperty]="'Name'"
            [OrderBy]="'Name'" 
            [AllowAddNew]="false" 
            formControlName="RoleID"
            [Disabled]="true"
            name="cmbUserRole"
            [Label]="'ACTION.PODESAVANJEAKCIJA.ROLA.SINGULAR'">
            </yt-dropdown-picklist>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
        <div class="col-12">
           <div class="form-group row">
             <div class="col-md-12">
               <yt-dropdown-picklist 
               [ModelName]="'action'" 
               [GetName]="'get'" 
               [ModelProperty]="'Model,Naziv'"
               [OrderBy]="'Model'" 
               [AllowAddNew]="false" 
               formControlName="ActionID"
               name="cmbUserRole"
               [Label]="'ACTION.PODESAVANJEAKCIJA.ACTION.SINGULAR'">
               </yt-dropdown-picklist>
             </div>
           </div>
         </div>
       </div>
       <div class="form-group row">
        <div class="col-md-1">
          <input style="width: 20px;" type="checkbox" name="chkGlavni" class="form-control" formControlName="Value"
            autocomplete="off">
        </div>
        <label class="col-form-label col-2"><span translate="ACTION.VALUE.SINGULAR"></span></label>
      </div>
</form>
</div>
<div class="modal-footer">
    <button type="submit" class="btn btn-primary" id="btnSave" (click)="Save()"><span>Sačuvaj</span></button>
    <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span>Odustani</span></button>
</div>